import {resolveGoogExport} from 'dgetz/tsclj'

export function staticUrl (s: string) {
    let staticUrl = resolveGoogExport('ladder.build.static_url');
    return staticUrl(s);
}
